/*
 * @Description: 积分商城商品管理相关接口
 * @Author: guqiang
 * @Date: 2021-10-13 17:39:52
 * @LastEditors: guqiang
 * @LastEditTime: 2021-11-01 09:25:53
 */
import request from './request';

// const mock = 'mock/139/api/saas';
const mock = '';
/**
 * @description: 新增商品
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435980
 * @return {*}
 */
export function postGoods(params) {
    return request('/mall/goods-spu', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 编辑商品
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435980
 * @return {*}
 */
export function putGoods(params) {
    return request('/mall/goods-spu', {
        method: 'PUT',
        params,
    });
}

/**
 * @description: 商品列表
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435983
 * @return {*}
 */
export function getGoods(params) {
    return request('/mall/goods-spu/list', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 通过商品Id查询商品详情
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435987
 * @return {*}
 */
export function getGoodsById(id) {
    return request(`${mock}/mall/goods-spu/${id}`, {
        method: 'GET',
    });
}

/**
 * @description: 商品上下架
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435985
 * @return {*}
 */
export function putGoodsLineStatus(params) {
    return request(`${mock}/mall/goods-spu/shelf`, {
        method: 'PUT',
        params,
    });
}

/**
 * @description: 商品类目
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435948
 * @return {*}
 */
export function getGoodCategorys(params) {
    return request(`${mock}/mall/goods-category/tree`, {
        method: 'GET',
        params,
    });
}

/**
 * @description: 通过商品类目Id查询商品类目
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435949
 * @return {*}
 */
export function getGoodCategoryById(id) {
    return request(`/mall/goods-category/${id}`, {
        method: 'GET',
    });
}

/**
 * @description: 商品规格列表
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435992
 * @return {*}
 */
export function getGoodSpecs(params) {
    return request(`${mock}/mall/goods-spu-spec/tree`, {
        method: 'GET',
        params,
    });
}

/**
 * @description: 通过规格id查询规格值
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435978
 * @return {*}
 */
export function getGoodSpecValueById(params) {
    return request('/mall/goods-spec-value/list', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 商店列表
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435978
 * @return {*}
 */
export function getShops(params) {
    return request(`${mock}/mall/shop/list-all`, {
        method: 'GET',
        params,
    });
}

/**
 * @description: 全部规格列表
 * @param {*}  http://yapi.iklicen.com/project/139/interface/api/435992
 * @return {*}
 */
export function getSpecs() {
    return request(`${mock}/mall/goods-spec/list`, {
        method: 'GET',
    });
}

/**
 * @description: 根据规格查询规格值列表
 * @param {*}  http://yapi.iklicen.com/project/139/interface/api/435978
 * @return {*}
 */
export function getSpeValuesBySpecId(params) {
    return request(`${mock}/mall/goods-spec-value/list`, {
        method: 'GET',
        params,
    });
}

/**
 * @description: 获取商品适用车型树
 */
export function getApplicableVehicleModels(params) {
    return request('/mall/goods-spu/applicable-vehicle-models', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 编辑商品适用车型
 */
export function EditApplicableVehicleModels(params) {
    return request('/mall/goods-spu/applicable-vehicle-models', {
        method: 'PUT',
        params,
    });
}
